import script from "./PhieuXuatKhoVatTuTableShell.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhieuXuatKhoVatTuTableShell.vue?vue&type=script&lang=ts&setup=true"

import "./PhieuXuatKhoVatTuTableShell.vue?vue&type=style&index=0&id=b109fc46&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b109fc46"]])

export default __exports__